import React from 'react';
import { Button, Checkbox, Col, Form, Input, Row, Space, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import './CustomerContactsFormList.css';

const { Text } = Typography;

interface CustomerContactsFormListProps {
  addLabel: string;
  contactLabel: string;
  nameLabel: string;
  phoneLabel: string;
  emailLabel: string;
  primaryLabel: string;
  removeLabel: string;
}

const CustomerContactsFormList: React.FC<CustomerContactsFormListProps> = ({
  addLabel,
  contactLabel,
  nameLabel,
  phoneLabel,
  emailLabel,
  primaryLabel,
  removeLabel
}) => (
  <Form.List name="contactPeople">
    {(fields, { add, remove }) => (
      <div className="customer-contacts-form-list">
        {fields.map((field, index) => (
          <div key={field.key} className="customer-contacts-form-list__item">
            <div className="customer-contacts-form-list__item-header">
              <Text className="customer-contacts-form-list__item-title">
                {contactLabel} {index + 1}
              </Text>

              {fields.length > 1 && (
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => remove(field.name)}
                  aria-label={removeLabel}
                />
              )}
            </div>

            <Row gutter={12}>
              <Col xs={24} md={12}>
                <Form.Item name={[field.name, 'name']} label={nameLabel}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name={[field.name, 'phone']} label={phoneLabel}>
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={[field.name, 'email']}
                  label={emailLabel}
                  rules={[{ type: 'email', message: emailLabel }]}
                >
                  <Input type="email" />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name={[field.name, 'isPrimary']}
                  valuePropName="checked"
                  label=" "
                  colon={false}
                >
                  <Checkbox>{primaryLabel}</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </div>
        ))}

        <Space>
          <Button
            type="dashed"
            icon={<PlusOutlined />}
            onClick={() => add({ name: '', phone: '', email: '', isPrimary: false })}
          >
            {addLabel}
          </Button>
        </Space>
      </div>
    )}
  </Form.List>
);

export default CustomerContactsFormList;
